export default __webpack_public_path__ + "static/media/CAF-logo.56b6d4f9.png";